var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOther = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 806.801 806.801",
    style: {
      enableBackground: "new 0 0 806.801 806.801"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M68.8,740.5c42.7,42.7,99.5,66.2,159.9,66.2c60.4,0,117.2-23.5,159.9-66.2l133-133c8.1-8.1,8.1-21.3,0-29.5L438.4,494.801 L365,568.2l23.101,23.101L313.7,665.7c-47,47-123.2,47-170.2,0l-2.5-2.5c-47-47-47-123.2,0-170.2l74.4-74.399l23.1,23.1 l73.4-73.399l-83.2-83.2c-8.1-8.1-21.3-8.1-29.5,0l-133,133C23.5,460.801,0,517.601,0,578c0,60.4,23.5,117.2,66.2,159.9 L68.8,740.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M738,66.3c-42.699-42.7-99.5-66.2-159.9-66.2s-117.199,23.5-159.9,66.2l-135.7,135.8c-8.1,8.1-8.1,21.3,0,29.5l83.2,83.2 l76.201-76.2l-23.201-23.2l74.4-74.4c47-47,123.201-47,170.201,0l2.5,2.5c47,47,47,123.2,0,170.2l-74.4,74.4L568.301,365 L492.1,441.2l83.201,83.2c8.1,8.1,21.299,8.1,29.5,0l135.799-135.8c42.701-42.7,66.201-99.5,66.201-159.9 c0-60.4-23.5-117.2-66.201-159.9L738,66.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.5,244.3c-9.801-9.8-22.5-14.6-35.301-14.6c-12.799,0-25.6,4.9-35.299,14.6l-22.201,22.1l-76.2,76.2l-53.699,53.7 L266.4,469.7l-22.1,22.101c-19.5,19.5-19.5,51.199,0,70.699c9.8,9.801,22.5,14.601,35.3,14.601s25.6-4.9,35.3-14.601l22.1-22.1 L410.4,467l53.699-53.699l76.201-76.2L562.4,315C582,295.5,582,263.8,562.5,244.3z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOther);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/other.cab8b8f214ed47b77aaf3697f9a41738.svg";